import { ComponentProps, FC } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import { useThrottle } from '@/common/hooks/useThrottle';

interface IconButtonProps extends ComponentProps<'button'> {
  id: string;
  Icon: FC<{ color?: string }>;
  iconColor?: string;
}

export const IconButton: FC<IconButtonProps> = ({
  id,
  Icon,
  iconColor,
  ...props
}) => {
  const throttledClick = useThrottle(props.onClick);
  return (
    <button
      {...props}
      id={`${id}-icon-button`}
      onClick={throttledClick}
      className={cn(styles.iconButton, props.className)}
    >
      <Icon color={iconColor} />
    </button>
  );
};
